export default "__VITE_ASSET__KxFnLS06__"